export default __webpack_public_path__ + "static/media/gallery 5.22f957ee.png";